import ctt from '@/utils/const';
import mutations from './mutations';
// import VueSocketIO from 'vue-socket.io';
// import Vue from 'vue';
// import { getToken } from '@/utils/utils';
// import { useHook } from './hooks';
// import Type from '@/store/mutation-type';
import { isAlarmOrWarn } from '@/utils/deviceUtils/state';
import { isArray } from '@/utils/is';

export default {
  namespaced: true,
  state: {
    deviceTree: null, // 获取设备的组织机构
    devicesSourseMap: [], // 设备菜单的souesemap
    deviceIdMap: {}, // 设备组织机构 id map
    deviceSNMap: {}, // 设备sn map
    deviceWorks: {}, // 设备健康和设备监测/检测
    devicesReport: [], // 设备监控状态报告
    webSocket: '', // 存储websocket对象
    wsOpen: false, // ws是否启动
    /** @type {{[index:string]: any}} 单个设备详细信息socket */
    singleDeviceDetail: {},
    /** @type {{sn: any}} 当前订阅的多台设备详情 */
    subDeviceMap: {},
    lockReconnect: false, // 是否重连
    snThreshold: '', // 阈值
    socketNum: 0,
    dataLoading: true, // 数据加载 默认true
    timer: null,
    onlineDetectionTimerMap: {} // 存储设备定时器编号，用于判断设备是否还连接
  },
  mutations,
  getters: {
    currentChooseDevice(state, _getters, rootState) {
      // 当前选择的设备
      const sn = rootState.route.params.sn;
      if (sn) return state.deviceSNMap[sn];
    },
    devicesReportWarn(state) {
      // 预警报告
      return state.devicesReport.filter(e => {
        return /^30[12]$/.test(e.code)
          ? e.eventData.state === ctt.POINT_STATE_WARN
          : e.state === ctt.POINT_STATE_WARN;
      });
    },
    devicesReportDanger(state) {
      // 报警报告
      return state.devicesReport.filter(e => {
        return /^30[12]$/.test(e.code)
          ? e.eventData.state === ctt.POINT_STATE_DANGER
          : e.state === ctt.POINT_STATE_DANGER;
      });
    },
    devicesSingleReport(state, _getters, rootState) {
      // 当前选择设备报告
      return state.devicesReport.filter(e => {
        return /^30[12]$/.test(e.code)
          ? e.eventData.sn === rootState.route.params.sn
          : e.sn === rootState.route.params.sn;
      });
    },
    alarmDeviceList(state, _, rootState) {
      return state.devicesSourseMap.filter(device => {
        if (rootState.app.silentList.includes(device.sn)) return false;
        return isAlarmOrWarn(device.state2);
      });
    },
    alarmFlag(_, getters) {
      // 0-正常, 1-预警, 2-报警
      let flag = 0;

      const alarmDeviceList = getters.alarmDeviceList;
      if (isArray(alarmDeviceList)) {
        alarmDeviceList.some(ele => {
          if (ele.state === ctt.POINT_STATE_DANGER || ele.state === ctt.POINT_STATE_HIGH_RISK) {
            flag = 2;
            return true;
          }
          if (ele.state === ctt.POINT_STATE_WARN) {
            flag = 1;
          }
        });
      }
      return flag;
    },
    singleDeviceMods(state, _getters, rootState) {
      try {
        const isHisDetail = !!rootState.route.params.eventId;
        return isHisDetail
          ? Object.keys(rootState.history.historyDetailData.mods || [])
          : Object.keys(state.singleDeviceDetail.mods || []);
      } catch (error) {
        return []; // 不需要打印error
      }
    }
  },
  actions: {
    register() {
      // const vueSocketIO = new VueSocketIO({
      //   // debug: process.env.NODE_ENV === 'development',
      //   debug: false,
      //   connection: `${window.location.protocol}//${window.location.hostname}:${process.env.VUE_APP_SOCKET_PORT}`,
      //   options: {
      //     path: `${process.env.VUE_APP_BASE_URL}/socket.io`,
      //     transports: ['websocket'],
      //     query: {
      //       token: getToken(),
      //       number: window.name || 0 // 多窗口socket
      //     }
      //   }
      // });
      // Object.seal(vueSocketIO);
      // Vue.use(vueSocketIO);
      // useHook(['reconnectRefresh'], vueSocketIO);
      // commit('SET_VUE_SOCKET_IO', vueSocketIO);
      // commit(Type.INTERVAL_UP);
    },
    clearAll({ state }) {
      state.deviceTree = null;
      state.devicesSourseMap = [];
      state.deviceIdMap = {};
      state.deviceSNMap = {};
      state.deviceWorks = {};
      state.devicesReport = [];
      state.webSocket = '';
      state.subDeviceMap = {};
      clearInterval(state.timer);
      state.timer = null;
      Object.values(state.onlineDetectionTimerMap).forEach(num => clearTimeout(num));
      state.onlineDetectionTimerMap = {};
    }
  }
};
